(function () {
    angular.module('PWAPoCApp').controller('containerEventsModalController', ContainerEventsModalController);

    ContainerEventsModalController.$inject = ['$scope', 'units', 'containersService', '$windowInstance', '$rootscope'];

    function ContainerEventsModalController($scope, units, containersService, $windowInstance, $rootscope) {

        var today = new Date();

        $scope.deviceLogs = [];
        $scope.containerIds = [];
        $scope.dateFromObject = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 14);
        $scope.dateToObject = today;

        $scope.applyDateFilter = applyDateFilter;

        initController();

        function initController() {
            $scope.logfilter = units.map(unit => {
                return {
                    externalDeviceId: unit.containerId,
                    from: $scope.dateFromObject,
                    to: $scope.dateToObject
                }
            });

            containersService.getLogsByExtDeviceIdAndSystemBulk($scope.logfilter)
                .then(response => {
                    $scope.deviceLogs = response.data;
                    $scope.containerEventsGridOptions = {
                        dataSource: new kendo.data.DataSource({
                            transport: {
                                read: function (options) {
                                    if ($scope.deviceLogs) {
                                        options.success($scope.deviceLogs);
                                    } else {
                                        options.error();
                                    }
                                },
                            },
                        }),
                        sortable: true,
                        filterable: true,
                        noRecords: true,
                        messages: {
                            noRecords: $rootscope.translate('routeStopCard.containerEvents.noRecords')
                        },
                        columns: [
                            {
                                field: 'time',
                                title: $rootscope.translate('routeStopCard.containerEvents.time'),
                                template: '#= kendo.toString(kendo.parseDate(time), "dd.MM.yyyy hh:mm:ss") #',
                                filterable: false
                            },
                            {
                                field: 'logAction',
                                title: $rootscope.translate('routeStopCard.containerEvents.logAction')
                            },
                            {
                                field: 'comment',
                                title: $rootscope.translate('routeStopCard.containerEvents.comment')
                            },
                            {
                                field: 'extUser',
                                title: $rootscope.translate('routeStopCard.containerEvents.user')
                            },
                        ]
                    };
                }).catch(err => {
                    console.error(err);
                });
        }

        function applyDateFilter() {
            $scope.logfilter.forEach(filter => {
                filter.from = $scope.dateFromObject;
                filter.to = $scope.dateToObject;
            });
            containersService.getLogsByExtDeviceIdAndSystemBulk($scope.logfilter)
                .then(response => {
                    $scope.deviceLogs = response.data;
                    $scope.containerEventsGridOptions.dataSource.read();
                }).catch(err => {
                    console.error(err);
                });
        }
    }
})();
